import { render, staticRenderFns } from "./editIcon.vue?vue&type=template&id=54f709b2&scoped=true&"
import script from "./editIcon.vue?vue&type=script&lang=js&"
export * from "./editIcon.vue?vue&type=script&lang=js&"
import style0 from "./editIcon.vue?vue&type=style&index=0&id=54f709b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f709b2",
  null
  
)

export default component.exports